module.exports = __webpack_public_path__ + "static/torm-symbol-SCAG-042fbcf1957f8478404bab31b9b717eb.png";